
import React from 'react';
import { LoginFormContainer } from 'features/auth';
import { Alert } from 'antd';
import MainLogo from 'img/Logo-signing.png';

const HomePage: React.FC = () => {
  return (
    <>
      <Alert
        message="This version is no longer supported"
        description={
          <>
            Please go to{' '}
            <a href='https://www.app.siadash.com/' target='_blank' rel='noopener noreferrer'>
              https://www.app.siadash.com/
            </a>
          </>
        }
        type='warning'
        showIcon
        style={{ width: '100%', margin: 0, borderRadius: 0 }}
      />
      <div className='signin-container'>
        <div className='logo-wrapper'>
          <img src={MainLogo} alt='Synergy Logo' />
        </div>
        <LoginFormContainer />
      </div>
    </>
  );
};

export default HomePage;
